/* eslint react/no-multi-comp: 0 */
import React, { Component } from 'react';
import closeClickOutside from 'react-click-outside';

import './Dropdown.css';

class DropdownItem extends Component {
  onClick = e => {
    e.preventDefault();
    this.props.onClick(this.props.id);
  };

  render() {
    const { title, subtitle, icon, emoji, ...rest } = this.props;

    return (
      <button className="dropdown__list-item" {...rest} onClick={this.onClick}>
        <span className={`icon ${!!emoji ? '' : icon}`}>{emoji}</span>
        {title}
        <span className="dropdown__list-item__subtitle">{subtitle}</span>
      </button>
    );
  }
}

class DropdownMenu extends Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };
  }

  componentDidMount() {
    window.addEventListener('popstate', this.closeDropDown);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.closeDropDown);
  }

  handleItemClick = id => {
    const { menuItems } = this.props;
    const item = menuItems[id];

    if (item && item.onClick) {
      item.onClick();
    }

    this.closeDropDown();
  };

  handleClickOutside() {
    this.closeDropDown();
  }

  closeDropDown = e => {
    if (e) {
      e.preventDefault();
    }

    this.setState({ isOpen: false });
  };

  toggleDropdown = e => {
    e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { menuItems } = this.props;
    const { isOpen } = this.state;

    return (
      <div className="dropdown-menu">
        <button className="open-btn" onClick={this.toggleDropdown}>
          <i className="icon ion-android-more-vertical" />
          <span className="open-btn__text">More...</span>
        </button>

        {isOpen && (
          <div className="dropdown-menu-list">
            <div className="dropdown-menu-list__content">
              {menuItems.map((item, index) => (
                <DropdownItem
                  key={item.title}
                  id={index}
                  title={item.title}
                  icon={item.icon}
                  emoji={item.emoji}
                  subtitle={item.subtitle}
                  onClick={this.handleItemClick}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

DropdownMenu.defaultProps = {
  menuItems: [],
};

export default closeClickOutside(DropdownMenu);



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.jsx